// removed by extract-text-webpack-plugin
module.exports = {"category":"_29gCpYivqAa2UX9dJsiX0q","groupCat":"wI0WGGt4oniuZgpwJhyTp","itemsCat":"_30lJTSgikbLmG-1eZ6Fea0","itemSpa":"sb3VoviwsAcL-pjRHUxVG","itemHair":"_2GYnrkSKqxMs3egkF55GH7","itemCosmetic":"_19I7VLow99kYLaixYj7qyR","itemHomeService":"_1fvHVElBb_8SbkQ1c6loSD","itemClinic":"_1hPaUCSCu-hAQ9IpNKo2eZ","itemFitness":"_1h8dh_tvtvtagVs1u_xVad","itemTatoo":"_507a2ByJq8Ctne0yb7C0h","itemSalonMiMong":"ufrcG_y8RVafh66rJMIUA","itemSpaChamDa":"_1KBNkSXU0ANeW9JbfIU3Hm","itemMassageGoiDau":"fnYc5l18RI7GRt__R0ZwJ","itemThamMyNhaKhoa":"MYdeHIi9YYmtsshYZtXUm","itemSalonTocMakeUp":"_3b-Gj7GdlkebKfRddEUntf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Partials/Category.scss
// module id = 1162
// module chunks = 0